var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{staticStyle:{"margin":"0 10px 10px 0"},attrs:{"type":"primary"},on:{"click":_vm.exportData}},[_vm._v("导出日志记录")]),_c('b',[_vm._v("注：这里只会显示成功保存到服务端的错误日志，而且页面错误日志不会在浏览器持久化存储，刷新页面即会丢失")]),_c('Table',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.errorList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }